const appConfig = {
    appId: "agentQore-bce47a74-8ea8-4f53-88d6-df17e6c0f925",
    appName: "Agent",
    site: 'agent-qore',
    icon: "https://nsdstaticasset.blob.core.windows.net/assets/Qore_Brand_Icons/ledgerQoreAppIcon.png"
};

export default appConfig;
